<template>
	<c-dialog ref="dialog" mode="slide" width="80vw" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="oversold.oversold_no" class="m-detail-tag flex-center-cross">
				<label>{{oversold.oversold_no}}</label>
				<c-state tag async dict="OVERSOLD_HANDLE_STATE" :value="oversold.handle_state"></c-state>
			</div>
		</template>

		<module>
			<module-col size="400">
				<c-detail class="m-detail-form">
					<c-detail-item label="超卖单号">
						{{oversold.oversold_no || '-'}}
					</c-detail-item>
					<c-detail-item label="产品信息">
						<c-state v-if="oversold.product_level" tag dict="LEVEL_TYPE" :value="oversold.product_level"></c-state>
						<span>{{oversold.product_name || '-'}}</span>
					</c-detail-item>
					<c-detail-item label="背贴码">
						{{oversold.produce_code || '-'}}
					</c-detail-item>
					<c-detail-item label="IMEI">
						{{oversold.imei || '-'}}
					</c-detail-item>
					<c-detail-item label="超卖渠道数">
						{{oversold.oversold_channel_count || '-'}}
					</c-detail-item>
					<c-detail-item label="最高销售价">
						{{formatPrice(oversold.max_sale_price)}}
					</c-detail-item>
					<c-detail-item label="处理状态">
						<c-state async dict="OVERSOLD_HANDLE_STATE" :value="oversold.handle_state"></c-state>
					</c-detail-item>
					<c-detail-item label="判定时间">
						{{oversold.create_date || '-'}}
					</c-detail-item>
					<template v-if="oversold.handle_state == 2">
						<c-detail-item label="保留渠道">
							{{oversold.confirm_channel_name || '-'}}
						</c-detail-item>
						<c-detail-item label="保留销售单号">
							{{oversold.confirm_order_no || '-'}}
						</c-detail-item>
						<c-detail-item label="保留订单销售价">
							{{formatPrice(oversold.confirm_sale_price)}}
						</c-detail-item>
						<c-detail-item label="预期结算金额">
							{{formatPrice(oversold.expect_settle_price)}}
						</c-detail-item>
						<c-detail-item label="处理人">
							{{oversold.handle_user_realname || '-'}}
						</c-detail-item>
						<c-detail-item label="处理时间">
							{{oversold.handle_date || '-'}}
						</c-detail-item>
					</template>
				</c-detail>
			</module-col>

			<module-col>
				<div class="m-card-wrap">
					<p v-if="canHandle" class="m-card-tip">请从以下各渠道订单中选择一单保留，其余订单将被取消</p>
					<div
						v-for="card in channelCards"
						:key="card.order_id"
						class="m-channel-card"
						:class="{'m-selected': canHandle && confirmOrderId == card.order_id, 'm-confirmed': card.confirm_flag == 1}"
						@click="selectCard(card)">
						<div class="m-card-head flex-center-cross">
							<span class="m-channel-name">{{card.channel_name || '-'}}</span>
							<c-state tag async dict="SALES_ORDER_STATE" :value="card.order_state"></c-state>
							<span v-if="card.confirm_flag == 1" class="m-confirm-flag">已确认保留</span>
						</div>
						<div class="m-card-body">
							<p><label>销售单号</label>{{card.order_no || '-'}}（{{card.third_party_order_no || '-'}}）</p>
							<p><label>销售价</label><span class="m-amount">{{formatPrice(card.sale_price)}}</span>　预期结算 {{formatPrice(card.expect_settle_amount)}}</p>
							<p><label>收货人</label>{{card.receiver_name || '-'}}</p>
							<p><label>收货地址</label>{{card.receiver_address || '-'}}</p>
							<p><label>付款时间</label>{{card.pay_date || '-'}}</p>
						</div>
					</div>
				</div>
			</module-col>
		</module>

		<template v-if="canHandle" #button>
			<c-button size="dialog" color="main" @click="submitHandle">确认处理</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'oversoldDetail',

		props: {
			//是否为处理模式（可选择保留订单并提交）
			handleable: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				oversoldId: '',
				oversold: {},
				channelCards: [],
				confirmOrderId: ''
			}
		},

		computed: {
			/*********当前是否可执行处理操作**********/
			canHandle() {
				return this.handleable && this.oversold.handle_state == 1;
			}
		},

		methods: {
			/*********打开抽屉**********/
			open(data = {}) {
				this.oversoldId = data.oversoldId;
				this.oversold = {};
				this.channelCards = [];
				this.confirmOrderId = '';
				this.$refs.dialog.open({title: this.handleable ? '超卖处理' : '超卖详情'});
				this.loadDetail();
			},

			/*********加载超卖详情**********/
			loadDetail() {
				this.request({
					url: '/oversold/sale/order/detail',
					data: {
						id: this.oversoldId
					},
					loading: true,
					success: data => {
						this.oversold = data.oversold || {};
						this.channelCards = data.channel_cards || [];
						//默认选中已确认保留的订单
						var confirmed = this.channelCards.find(item => item.confirm_flag == 1);
						if (confirmed) this.confirmOrderId = confirmed.order_id;
					}
				});
			},

			/*********选择保留订单**********/
			selectCard(card) {
				if (!this.canHandle) return;
				this.confirmOrderId = card.order_id;
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********确认处理**********/
			submitHandle() {
				if (!this.confirmOrderId) {
					this.$message({message: '请选择要保留的订单', type: 'warn'});
					return;
				}
				this.request({
					url: '/oversold/sale/order/handle',
					data: {
						id: this.oversoldId,
						confirm_order_id: this.confirmOrderId
					},
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || '处理成功', type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				});
			},

			/*********关闭抽屉**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-tag {
		gap: 8px;
		font-size: 14px;
		font-weight: bold;
	}

	.m-card-wrap {
		flex: 1;
		padding: 10px;
		overflow-y: auto;
	}

	.m-card-tip {
		margin-bottom: 10px;
		font-size: 13px;
		color: #fa8c16;
	}

	.m-channel-card {
		margin-bottom: 12px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		background: #fff;
		transition: border-color .2s, box-shadow .2s;

		&.m-selected {
			border-color: #1890ff;
			box-shadow: 0 0 0 2px rgba(24, 144, 255, .15);
		}

		&.m-confirmed {
			border-color: #52c41a;
		}

		.m-card-head {
			gap: 8px;
			padding: 8px 12px;
			background: #fafafa;
			border-bottom: 1px solid #f0f0f0;

			.m-channel-name {
				font-size: 14px;
				font-weight: bold;
				color: #333;
			}

			.m-confirm-flag {
				margin-left: auto;
				font-size: 12px;
				color: #52c41a;
			}
		}

		.m-card-body {
			padding: 8px 12px;
			line-height: 24px;
			font-size: 13px;
			color: #333;

			label {
				display: inline-block;
				width: 70px;
				color: #999;
			}

			.m-amount {
				font-weight: bold;
				color: #e53e3e;
			}
		}
	}
</style>
